import React from 'react';
import { useImpressionRef } from '@noths/polaris-client-react-hooks';

import * as styles from './TrustCarousel.styles';

export interface TrustItemProps {
  headerText: string;
  heading: string;
  links?: {
    href: string;
    text: string;
  }[];
  onItemVisible?: (heading: string) => void;
  subHeading: string;
}

export const TrustItem = ({
  headerText,
  heading,
  links = [],
  onItemVisible,
  subHeading,
}: TrustItemProps) => {
  const trustItemRef = useImpressionRef<HTMLLIElement>(() => {
    onItemVisible?.(`${headerText} ${heading}`);
  });

  return (
    <li css={styles.item} ref={trustItemRef}>
      <h4 css={styles.itemHeader}>
        <span>{headerText}</span>
      </h4>
      <h5>{heading}</h5>
      <p>{subHeading}</p>
      {links.map((link) => (
        <a css={styles.itemLink} href={link.href} key={link.href}>
          {link.text}
        </a>
      ))}
    </li>
  );
};
